<h1>{{blockMessage}}</h1>
<br>
<h3>Please contact your administartor.</h3>
<br>
<button  class="block-btn" (click)="onNoClick()">OK</button>